module.exports = __webpack_public_path__ + "img/613.58e16f2e.jpg";